import { Theme, styled } from '@mui/material/styles'
import { componentSizes } from '@theme/variables'

export const StyledCommonLayout = styled('div')<{ $fixedViewport: boolean; $backgroundImage: string }>`
  width: 100vw - 16px;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  background-size: 1913px 1728px;
  background-repeat: no-repeat;

  ${props =>
    props.$fixedViewport
      ? `
          position: fixed;
          overflow: hidden;
          height: 100%;
          background-image: url('${props.$backgroundImage}');
        `
      : `
          background-image: url('${props.$backgroundImage}');
        `}
`

export const StyledCommonLayoutMainWrapper = styled('div')<{ $fixedViewport: boolean }>`
  display: flex;
  flex: 1 0;
  ${props =>
    props.$fixedViewport
      ? `
          height: 100%;
          overflow: hidden;
        `
      : ''}
`

export const StyledCommonLayoutMainContent = styled('div')`
  display: flex;
  padding-bottom: 16px;
  padding-right: 16px;
  overflow: auto;
  width: calc(100% - ${componentSizes.leftNavWidth});

  ${(props: { theme: Theme }) => props.theme.breakpoints.down('sm')} {
    width: calc(100% - ${componentSizes.leftNavWidth} - 16px);
    padding-right: 0;
  }
`
